import { Component, OnInit } from '@angular/core';
import { MainFilterClass } from '../main-filter';

@Component({
  selector: 'app-boolean-filter',
  templateUrl: './boolean-filter.component.html',
  styleUrls: ['./boolean-filter.component.less']
})
export class BooleanFilterComponent extends MainFilterClass {
  ngOnInit() {
  }

}
